import { render, staticRenderFns } from "./WorkflowTransitionValidationFields.vue?vue&type=template&id=406a9630&lang=pug&"
import script from "./WorkflowTransitionValidationFields.vue?vue&type=script&setup=true&lang=js&"
export * from "./WorkflowTransitionValidationFields.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports